import { registerDynamicZonesDefinition } from './dynamic-zones';
import { registerEnumsDefinition } from './enums';
import { registerInputsDefinition } from './inputs';
import { registerFiltersDefinition } from './filters';

export default {
  registerDynamicZonesDefinition,
  registerFiltersDefinition,
  registerInputsDefinition,
  registerEnumsDefinition,
};
